import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Typography, Box } from '@material-ui/core';
import Button from '../../../components/form/elements/Button';
import { BUTTON_COLOR, BUTTON_SIZE, BUTTON_TYPE, BUTTON_VARIANT } from '../../../components/form/enum/formProps';
import { useAuthLocation } from '../../auth/hooks/useAuthLocation';
import './../Error.scss';

const AccessDenied = () => {
  const { userLogin } = useAuthLocation();
  const { t } = useTranslation();

  return (
    <Container className="Error-Container">
      <Typography variant="h3">{t('error.403.title')}</Typography>
      <Typography variant="h4">{t('error.403.content')}</Typography>
      <Box display="flex" justifyContent="center">
        <Button
          onClick={() => userLogin()}
          color={BUTTON_COLOR.SECONDARY}
          type={BUTTON_TYPE.BUTTON}
          size={BUTTON_SIZE.LARGE}
          variant={BUTTON_VARIANT.CONTAINED}
          text="auth.login"
        />
      </Box>
    </Container>
  );
};

export default AccessDenied;
